<div class="mb-2">
  <div class="flex" [ngClass]="centered() ? 'justify-center text-center' : 'justify-between'">
    <h2 class="text-lg font-medium" [ngClass]="{'text-center': centered(), 'text-xl': size() === 'large'}"><ng-content/></h2>
  </div>
</div>
